const FOOTER_LINKS = [
  { label: "要求速览", id: "overview" },
  { label: "格式规范", id: "format" },
  { label: "字数与原创", id: "word-copyright" },
  { label: "审核标准", id: "review" },
  { label: "投稿流程", id: "process" },
  { label: "立即投稿", id: "submit" },
  { label: "常见问题", id: "faq" },
];

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  return (
    <footer className="bg-secondary-50 py-14 text-secondary-950">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <span className="text-lg leading-none">🍉</span>
              </span>
              <span className="font-display text-xl text-primary-700">吃瓜投稿</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-secondary-900">
              吃瓜投稿是一个专注内容审核与分发的投稿平台。我们把投稿的格式、字数、原创版权与审核标准讲得明明白白，让每一块好瓜都不被辜负。
            </p>
            <div className="mt-5 space-y-2 text-sm text-secondary-900">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-700"></i> tougao@chigua.example.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line text-secondary-700"></i> 投稿审核时间：工作日 9:00–18:00
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-2 md:gap-16">
            <div>
              <h4 className="mb-4 font-bold text-foreground-900">快速导航</h4>
              <ul className="space-y-2.5">
                {FOOTER_LINKS.slice(0, 4).map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToId(link.id)}
                      className="text-sm text-secondary-900 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="mb-4 font-bold text-foreground-900">投稿专区</h4>
              <ul className="space-y-2.5">
                {FOOTER_LINKS.slice(4).map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToId(link.id)}
                      className="text-sm text-secondary-900 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-secondary-200/80 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-900">
            © {new Date().getFullYear()} 吃瓜投稿 投稿平台 · 内容仅作示例，请勿虚构权威资质
          </p>
          <div className="flex items-center gap-3 text-secondary-900">
            <span className="text-xs">关注我们</span>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label="微博"
              className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label="小红书"
              className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-red-packet-line"></i>
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label="公众号"
              className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-wechat-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}